import { HttpInterceptorFn } from '@angular/common/http';
import { UrlUtils } from '../shared/utils/url.utils';
import { RestApiBase } from '../shared/configurations/rest-api-base.config';

export const institutionInterceptor: HttpInterceptorFn = (req, next) => {
    const institution = UrlUtils.getParam('institution');
    let newReq = req;
    if (req.url.includes(RestApiBase.API_ROOT) && institution) {
        newReq = req.clone({
            params: req.params.set('institution', institution),
        });
    }
    return next(newReq);
};
